import React, {useRef} from "react";
import {Button, Card, Col, Form, Row, Input, Select, Spin} from "antd";
import {
  GlobalOutlined,
  HomeOutlined,
  LoadingOutlined,
  LockOutlined,
  MailOutlined,
  PhoneOutlined,
  UserOutlined
} from "@ant-design/icons";
import {countries} from "../../../data/countries";
import ReCAPTCHA from "react-google-recaptcha";
import {RECAPTCHA_SITE_KEY} from "../../../constants";

export const CustomerForm = (props) => {
  const { isRegistering } = props;
  const recaptchaRef = useRef(null)

  const handleClick = async (values) => {
    props.handleClick({...values, region: values.city}).then(()=>{
      if(recaptchaRef?.current) {
        recaptchaRef.current.reset();
      }
    })
  }

  return (
    <Row>
      <Col span={24}>
        <Form
            name={'register-customer-regional'}
            onFinish={handleClick}
        >
          <Card
            size={"small"}
            bodyStyle={{paddingBottom: 0}}
          >
            <Row gutter={10}>
              <Col span={12}>
                <span className={"loginLabel"}>Email</span>
                <Form.Item
                  name={'email'}
                  rules={[
                    {required: true, message: 'This field is required'},
                    {type: 'email', message: 'Please enter a valid email address'},
                  ]}
                  validateTrigger={'onSubmit'}

                >
                  <Input
                    placeholder="Enter your email address"
                    prefix={<MailOutlined />}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <span className={"loginLabel"}>Password</span>
                <Form.Item
                  name={'password'}
                  rules={[
                    {required: true, message: 'This field is required'},
                    {type: 'string', min: 6 ,message: 'Password must be 6 characters or longer'},
                    {type: 'string', max: 60 ,message: 'Password too long!'},
                  ]}
                  validateTrigger={'onSubmit'}
                >
                  <Input.Password
                    placeholder="Enter your password"
                    prefix={<LockOutlined />}
                    autoComplete={'current-password'}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={10}>
              <Col span={12}>
                <span className={"loginLabel"}>Full Name</span>
                <Form.Item
                  name={'name'}
                  rules={[
                    {required: true, message: 'This field is required'},
                    {type: 'string', min: 2 ,message: 'Full name must be 2 characters or longer'},
                    {type: 'string', max: 80 ,message: 'Full name too long!'},
                  ]}
                  validateTrigger={'onSubmit'}
                >
                  <Input
                    placeholder="Enter your full name"
                    prefix={<UserOutlined />}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <span className={"loginLabel"}>Phone</span>
                <Form.Item
                  name={'phone'}
                  rules={[
                    {required: true, message: 'This field is required'},
                    {type: 'string', min: 6 ,message: 'Contact number must be 6 digits or longer'},
                    {type: 'string', max: 60 ,message: 'Contact number too long!'},
                  ]}
                  validateTrigger={'onSubmit'}
                >
                  <Input
                    placeholder="Enter your phone number"
                    prefix={<PhoneOutlined />}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={10}>
              <Col span={12}>
                <span className={"loginLabel"}>Country</span>
                <Form.Item
                  name={'country'}
                  rules={[
                    {required: true, message: 'This field is required'},
                  ]}
                  validateTrigger={'onSubmit'}
                >

                  <Select
                    showSearch
                    style={{width: '100%'}}
                    prefix={<GlobalOutlined />}
                    placeholder="Select your country"
                    optionFilterProp="children"
                    notFoundContent={"Country not found"}
                    filterOption={(input, option) =>
                      option.children[2].toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    autoComplete="new-password"
                  >
                    {
                      countries.map(item => {
                        return (
                          <Select.Option key={item.name} value={item.name} className={"countrySelect"}>
                            <img src={item.flag} alt="" style={{position: "relative", top: -2, width: 18}}/> {item.name}
                          </Select.Option>
                        )
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col  span={12}>
                <span className={"loginLabel"}>City</span>
                <Form.Item
                  name={'city'}
                  rules={[
                    {required: true, message: 'This field is required'},
                    {type: 'string', min: 2 ,message: 'City name must be 2 characters or longer'},
                    {type: 'string', max: 60 ,message: 'City name too long!'},
                  ]}
                  validateTrigger={'onSubmit'}
                >
                  <Input
                    placeholder="Enter your city"
                    prefix={<GlobalOutlined />}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={10}>
              <Col span={12}>
                <span className={"loginLabel"}>Postal Code</span>
                <Form.Item
                  name={'postalCode'}
                  rules={[
                    {required: true, message: 'This field is required'},
                    {type: 'string', min: 2 ,message: 'Postal code must be 2 digits or longer'},
                  ]}
                  validateTrigger={'onSubmit'}
                >
                  <Input
                    prefix={<GlobalOutlined />}
                    placeholder="Enter your postal code"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <span className={"loginLabel"}>Address</span>
                <Form.Item
                  name={'address'}
                  rules={[
                    {required: true, message: 'This field is required'},
                    {type: 'string', min: 2 ,message: 'Address must be 2 characters or longer'},
                    {type: 'string', max: 60 ,message: 'Address too long!'},
                  ]}
                  validateTrigger={'onSubmit'}
                >
                  <Input
                    placeholder="Enter your address"
                    prefix={<HomeOutlined />}
                  />
                </Form.Item>
              </Col>
            </Row>
            <div style={{display: "flex", justifyContent: "center"}}>
              <div style={{position: "absolute", marginTop: 25}}>
                <Spin indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />}/>
              </div>
              <div style={{textAlign: "left", zIndex: 2}}>
                <Form.Item
                  name={"reCaptcha"}
                  rules={[
                    {required: true, message: 'reCaptcha is required'},
                  ]}
                  className={"reCaptchaFormItem"}
                  validateTrigger={'onSubmit'}
                >
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={RECAPTCHA_SITE_KEY}
                  />
                </Form.Item>
              </div>
            </div>
          </Card>
          <Form.Item>
            <div style={{display: "flex", width: '100%', justifyContent: "center"}}>
              <Button
                style={{width: '100%', marginTop: '10px', maxWidth: 500}}
                type="primary"
                htmlType="submit"
                className={"loginText darkButton"}
                loading={isRegistering}
              >
                Sign Up
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );
}